import { render, staticRenderFns } from "./PortalFormModal.vue?vue&type=template&id=6a7cc8d2&scoped=true"
import script from "./PortalFormModal.vue?vue&type=script&lang=js"
export * from "./PortalFormModal.vue?vue&type=script&lang=js"
import style0 from "./PortalFormModal.vue?vue&type=style&index=0&id=6a7cc8d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cc8d2",
  null
  
)

export default component.exports